<template>
    <el-dialog
            :title="!dataForm.id ? '新增' : '修改'"
            :close-on-click-modal="false"
            :visible.sync="visible">
        <el-form :model="dataForm" ref="dataForm" @keyup.enter.native="dataFormSubmit()"
                 label-width="120px">
            <el-form-item label="名称" prop="name">
                <el-input v-model="dataForm.displayName" placeholder="名称"></el-input>
            </el-form-item>
            <el-form-item label="数据集代码" prop="description">
                <el-input v-model="dataForm.datasetCode" placeholder="数据集代码"></el-input>
            </el-form-item>
            <el-form-item label="表名" prop="description">
                <el-input v-model="dataForm.tableName" placeholder="表名"></el-input>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="dataFormSubmit()">确定</el-button>
    </span>
    </el-dialog>
</template>

<script>
    export default {
        props: ['mainContentViewHeight'],
        data() {
            return {
                visible: false,
                dataForm: {
                    id: '',
                    displayName: '',
                    datasetCode: '',
                    tableName: '',
                    busiType: 'GC'
                }
            }
        },
        methods: {
            init(id,busiType) {
                this.dataForm.id = id || '';
                if(!id && busiType){
                    this.dataForm.busiType = busiType;
                }
                this.visible = true;
                if (this.dataForm.id) {
                    // debugger
                    this.$httpReq({
                        url: '/customform/tablemeta/get?id=' + this.dataForm.id,
                        method: 'get',
                        baseURL: process.env.VUE_APP_proxybaseurl + ''
                    }).then(({data}) => {
                        if (data && data.code === '1') {
                            this.dataForm= {...data.data}
                        }
                    })
                }
            },
            // 表单提交
            dataFormSubmit() {
                this.$httpReq({
                    url: '/customform/tablemeta/save',
                    method: 'post',
                    baseURL: process.env.VUE_APP_proxybaseurl + '',
                    data: this.dataForm
                }).then(({data}) => {
                    if (data && data.code === '1') {
                        this.$message({
                            message: '操作成功',
                            type: 'success',
                            duration: 1500,
                            onClose: () => {
                                this.visible = false
                                this.$emit('refreshDataList')
                            }
                        })
                    } else {
                        this.$message.error(data.msg)
                    }
                })
            }
        }
    }
</script>
